const MomentumIcon = ({ size = 25 }: { size?: number | string }) => (
  <img
    src="/momentum_logo.png"
    alt="Momentum"
    width={size}
    height={size}
    style={{ objectFit: 'contain' }}
  />
);

export default MomentumIcon;
